import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AppLayout from '../components/AppLayout';
import PageTitle from '../components/PageTitle';
import '../styles/pages/LoginPage.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    document.title = 'ログイン | はしもと栄養パートナー';
  }, []);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleTestAccountClick = () => {
    setFormData({
      email: 'local-test@example.com',
      password: 'test123'
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(formData.email, formData.password);

      // Wait for state updates before navigation
      await new Promise(resolve => setTimeout(resolve, 100));

      navigate('/chat');
    } catch (err) {
      setError(err.userMessage || err.response?.data?.message || err.message || 'ログインに失敗しました。もう一度お試しください。');
    } finally {
      setLoading(false);
    }
  };

  // Test account auto-fill removed for security reasons

  return (
    <AppLayout showMenu={false}>
      <div className="text-center mb-6">
        <img
          src="/tsumugi.png"
          alt="つむぎ"
          className="mx-auto mb-4 login-page__mascot-img"
        />
        <h1 className="text-2xl font-bold text-text-main mb-2">おかえりなさい</h1>
        <p className="text-hint">つむぎがお待ちしていました</p>
      </div>

      <div className="tsumugi-container py-6">
        <form onSubmit={handleSubmit}>
          <div className="tsumugi-card mb-4">
            {error && (
              <div className="tsumugi-error-box">
                <div className="tsumugi-error-box__icon">⚠️</div>
                <div className="tsumugi-error-box__text">{error}</div>
              </div>
            )}

            <div className="mb-4">
              <label htmlFor="email" className="tsumugi-form-label">
                メールアドレス
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="tsumugi-form-input"
                placeholder="your@email.com"
              />
            </div>

            <div className="mb-4">
              <label htmlFor="password" className="tsumugi-form-label">
                パスワード
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={formData.password}
                onChange={handleChange}
                className="tsumugi-form-input"
                placeholder="••••••••"
              />
            </div>

            <div className="mb-4 text-right">
              <Link to="/forgot-password" className="text-sm login-page__forgot-password-link">
                パスワードをお忘れですか？
              </Link>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="tsumugi-btn tsumugi-btn-primary w-full"
            >
              {loading ? 'ログイン中...' : 'ログイン'}
            </button>

            <div className="mt-4 text-center text-sm login-page__register-link">
              アカウントをお持ちでない方は{' '}
              <Link to="/register" className="font-medium login-page__register-link-text">
                新規登録
              </Link>
            </div>
          </div>
        </form>

        <div className="tsumugi-card text-center">
          <h4 className="login-page__how-to-use-title">初めてご利用の方</h4>
          <Link
            to="/how-to-use"
            className="inline-flex items-center login-page__how-to-use-link"
          >
            <span className="mr-2">📖</span>
            使い方ガイドを見る
          </Link>
        </div>

        <div
          className="tsumugi-card login-page__test-account-card"
          onClick={handleTestAccountClick}
        >
          <h4 className="login-page__test-account-title">🧪 テストアカウント (プレミアム)</h4>
          <div className="login-page__test-account-content">
            <p className="login-page__test-account-email">メール: <strong className="login-page__test-account-value">local-test@example.com</strong></p>
            <p className="login-page__test-account-password">パスワード: <strong className="login-page__test-account-value">test123</strong></p>
            <p className="login-page__test-account-hint">👆 クリックで自動入力</p>
          </div>
        </div>

        <div className="mt-4 text-center">
          <Link to="/" className="text-sm login-page__home-link">
            ← ホームに戻る
          </Link>
        </div>
      </div>
    </AppLayout>
  );
};

export default LoginPage;